import { PagedReducer, PagedReducerReset, DispatchReset } from "base/src/utils/reducerUtil";
import { CAMPANHAS_PEDIDORESGATE_LOTE, CAMPANHAS_USUARIO_ALL, CampanhasActionTypes, CampanhasState } from "../../../types/campanha/campanhas";
import ValidationResult from "domain/types/global/validationResult";
import { IPagedListResponse } from "domain/types/global/pagedListResponse";
import { CampanhaPedidoResgateResponse } from "../../../types/campanha/campanhaPedidoResgateResponse";

const INITIAL_STATE: CampanhasState = {
  campanhasAll: [],
  CampanhasPedidoResgateLote: undefined,
  mudancaStatus: {} as ValidationResult,
};

export function CampanhasReducer(
  state = INITIAL_STATE,
  action: CampanhasActionTypes
): CampanhasState {
  switch (action.type) {
    case CAMPANHAS_USUARIO_ALL:
      return { ...state, campanhasAll: action.payload };
    case CAMPANHAS_PEDIDORESGATE_LOTE:
      return PagedReducer(state, "CampanhasPedidoResgateLote", action.payload, "CampanhaPedidoResgateID", CAMPANHAS_PEDIDORESGATE_LOTE)
    case DispatchReset(CAMPANHAS_PEDIDORESGATE_LOTE):
      return PagedReducerReset(state, "CampanhasPedidoResgateLote", {} as IPagedListResponse<CampanhaPedidoResgateResponse>, "CampanhaPedidoResgateID", CAMPANHAS_PEDIDORESGATE_LOTE)
    default:
      return state;
  }
}